// comparison = comparison.replace(/<>/g, "ne"):
// comparison = comparison.replace(/>=/g, "ge"):
// comparison = comparison.replace(/>/g, "gt"):
// comparison = comparison.replace(/<=/g, "le"):
// comparison = comparison.replace(/</g, "lt"):
// comparison = comparison.replace(/==/g, "eq"):
// comparison = comparison.replace(/!=/g, "ne"):
// comparison = comparison.replace(/=/g, "eq"):
// comparison = comparison.replace(/not/g, "not"):
// comparison = comparison.replace(/like/g, "like"):
// comparison = comparison.replace(/contains/g, "contains"):
// comparison = comparison.replace(/starts/g, "starts"):
// comparison = comparison.replace(/ends/g, "ends"):
// comparison = comparison.replace(/excludes/g, "excludes"):
import { FilterConfig } from "../../../../../utils/getFilterConfigByType";
import { DropdownOption } from "@agilant/toga-blox/dist/components/SearchInput/SearchNumberInput";
export interface ExtendedDropdownOption extends DropdownOption {
	name: string;
}
export const FILTERFIELDS: Record<string, FilterConfig> = {
	DATE: {
		filterIcon: "calendar",
		filterWeight: "regular",
		inputType: "date",
		hasToggle: true,
		dropDownOptions: [
			{ label: "Exactly", value: "in:", uuid: "1" },
			{ label: "Less than", value: "lt:", uuid: "2" },
			{ label: "More than", value: "gt:", uuid: "3" },
		],
	},
	BOOLEAN: {
		filterIcon: "list",
		filterWeight: "regular",
		inputType: "multiSelect",
		isBoolean: true,
		dropDownOptions: [
			{ uuid: "22", label: "True", value: "1", name: "True" },
			{ uuid: "33", label: "False", value: "0", name: "False" },
		],
	},
	STATUS: {
		filterIcon: "list",
		filterWeight: "regular",
		inputType: "multiSelect",
		dropDownOptions: [
			{
				uuid: "11",
				label: "Fulfilled",
				value: "fulfilled",
				name: "Fulfilled",
			},
			{
				uuid: "12",
				label: "Pending Approval",
				value: "pendingApproval",
				name: "Pending Approval",
			},
			{
				uuid: "13",
				label: "Pending Fulfillment",
				value: "pendingFulfillment",
				name: "Pending Fulfillment",
			},
			{
				uuid: "14",
				label: "Partially Fulfilled",
				value: "partiallyFulfilled",
				name: "Partially Fulfilled",
			},
			{
				uuid: "15",
				label: "Pending Billing",
				value: "pendingBilling",
				name: "Pending Billing",
			},
			{
				uuid: "16",
				label: "Pending Billing/Partially Fulfilled",
				value: "pendingBillingPartiallyFulfilled",
				name: "Pending Billing/Partially Fulfilled",
			},
			{ uuid: "17", label: "Billed", value: "billed", name: "Billed" },
			{
				uuid: "18",
				label: "Canceled",
				value: "canceled",
				name: "Canceled",
			},
			{ uuid: "19", label: "Closed", value: "closed", name: "Closed" },
			{
				uuid: "20",
				label: "Pending Initial Approval",
				value: "pendingInitialApproval",
				name: "Pending Initial Approval",
			},
		],
	},
	NUMBER: {
		filterIcon: "filter",
		filterWeight: "solid",
		inputType: "number",
		hasToggle: true,
		dropDownOptions: [
			{ label: "Exactly", value: "in:", uuid: "1" },
			{ label: "Less than", value: "lt:", uuid: "2" },
			{ label: "More than", value: "gt:", uuid: "3" },
		],
	},

	CURRENCY: {
		filterIcon: "filter",
		filterWeight: "solid",
		inputType: "number",
		hasToggle: true,
		dropDownOptions: [
			{ label: "Exactly", value: "in:", uuid: "1" },
			{ label: "Less than", value: "lt:", uuid: "2" },
			{ label: "More than", value: "gt:", uuid: "3" },
		],
	},

	STRING: {
		filterIcon: "magnifyingGlass",
		filterWeight: "regular",
		inputType: "text",
		dropDownOptions: [
			{ label: "Starts with", value: "", uuid: "1" },
			{ label: "Ends with", value: "ends:", uuid: "2" },
			{ label: "Exactly", value: "in:", uuid: "3" },
			{ label: "Includes", value: "contains:", uuid: "4" },
			{ label: "Excludes", value: "excludes:", uuid: "5" },
		],
	},

	DEFAULT: {
		filterIcon: "magnifyingGlass",
		filterWeight: "regular",
		inputType: "text",
		dropDownOptions: [
			{ label: "Starts with", value: "", uuid: "1" },
			{ label: "Ends with", value: "ends:", uuid: "2" },
			{ label: "Exactly", value: "eq:", uuid: "3" },
			{ label: "Includes", value: "contains:", uuid: "4" },
			{ label: "Excludes", value: "excludes:", uuid: "1" },
		],
	},
};
